import type { CatalogItemBase } from "building-types/entities/catalogItemBase";
import type { Table } from "common/data/table";
import type { ForeignEntityId } from "../handles/foreignEntityId";

export enum WallCondition {
  EXTERIOR_INTERIOR = "EXTERIOR_INTERIOR",
  EXTERIOR_GARAGE = "EXTERIOR_GARAGE",
  EXTERIOR_PLUMBING = "EXTERIOR_PLUMBING",
  EXTERIOR_DORMER = "EXTERIOR_DORMER",
  EXTERIOR_GABLE_END = "EXTERIOR_GABLE_END",
  EXTERIOR_CRIPPLE = "EXTERIOR_CRIPPLE",

  INTERIOR_INTERIOR = "INTERIOR_INTERIOR",
  INTERIOR_GARAGE = "INTERIOR_GARAGE",
  INTERIOR_PLUMBING = "INTERIOR_PLUMBING",

  INTERIOR_ROOF = "INTERIOR_ROOF", // halfstory walls on outside edges but under a roof and not exposed to exterior
  INTERIOR_FURRING = "INTERIOR_FURRING", // non structural framing adjacent to foundations
}

export interface WallConditionData {
  readonly wallTypeId: ForeignEntityId<"WALL_TYPE">;
}

export type WallConditionTable = { [key in WallCondition as string]: WallConditionData };

export interface WallType extends CatalogItemBase<"WALL_TYPE"> {
  // this is a catalog type without an id primary key field (it just uses the key as the id)
  readonly name: string;
  readonly structuralMaterialId: string;
  readonly foundationMaterialId?: string;
  readonly exteriorSubstrateMaterialId?: string;
  readonly membraneMaterialId?: string;
  readonly thermalMaterialId?: string;
}

export type WallTypeTable = Table<WallType>;
